import { UploadOutlined } from "@ant-design/icons";
import { Button, DatePicker, Form, Input, Select, Space, Upload } from "antd";
import { ModalComponentProps } from "../../types";
import CustomModal from "../ui/CustomModal";

const { Option } = Select;

export default function EditBusinessInfoModal({
  handleClose,
  data,
  type,
  ...rest
}: ModalComponentProps) {
  const [form] = Form.useForm();

  return (
    <CustomModal
      title="Edit Business Info"
      {...rest}
      handleClose={handleClose}
      width={800}
      footer={null}
    >
      <Form
        form={form}
        layout="vertical"
        // onFinish={onSubmit}
        className="space-y-4"
      >
        <div className="grid grid-cols-3 gap-4">
          <Form.Item name="logo" label="Business Logo">
            <Upload beforeUpload={() => false}>
              <Button icon={<UploadOutlined />}>Browse file</Button>
            </Upload>
          </Form.Item>

          <Form.Item
            name="companyName"
            label="Company Name"
            rules={[{ required: true }]}
          >
            <Input placeholder="Enter Company name" />
          </Form.Item>

          <Form.Item
            name="email"
            label="Business Email"
            rules={[{ required: true, type: "email" }]}
          >
            <Input placeholder="Enter business email" />
          </Form.Item>

          <Form.Item
            name="mobile"
            label="Mobile Number"
            rules={[{ required: true }]}
          >
            <Input placeholder="+880 XXXX XXXX XXX" />
          </Form.Item>

          <Form.Item
            name="location"
            label="Company Location"
            rules={[{ required: true }]}
          >
            <Select placeholder="Select">
              <Option value="dhaka">Dhaka</Option>
              <Option value="chittagong">Chittagong</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="address"
            label="Full Address"
            rules={[{ required: true }]}
          >
            <Input placeholder="Enter full address" />
          </Form.Item>
        </div>

        <div className="bg-gray-100  rounded-lg space-y-4">
          <div className="bg-[#F0F3F9] p-4 text-lg font-semibold mb-4 rounded-[6px] h-[42px] text-display-body text-base flex items-center justify-start gap-2 flex-shrink-0">
            Documents
          </div>
          <div className="grid grid-cols-3 gap-4">
            <Form.Item name="tinCertificate" label="TIN Certificate">
              <Upload beforeUpload={() => false}>
                <Button icon={<UploadOutlined />}>Browse file</Button>
              </Upload>
            </Form.Item>

            <Form.Item name="tinIssueDate" label="Issue Date">
              <DatePicker format="DD MMM, YYYY" className="w-full" />
            </Form.Item>

            <Form.Item name="tinExpireDate" label="Expire Date">
              <DatePicker format="DD MMM, YYYY" className="w-full" />
            </Form.Item>

            <Form.Item name="tradeLicense" label="Trade License">
              <Upload beforeUpload={() => false}>
                <Button icon={<UploadOutlined />}>Browse file</Button>
              </Upload>
            </Form.Item>

            <Form.Item name="tradeIssueDate" label="Issue Date">
              <DatePicker format="DD MMM, YYYY" className="w-full" />
            </Form.Item>

            <Form.Item name="tradeExpireDate" label="Expire Date">
              <DatePicker format="DD MMM, YYYY" className="w-full" />
            </Form.Item>
          </div>
        </div>

        <div className="bg-gray-100  rounded-lg space-y-4">
          <div className="bg-[#F0F3F9] p-4 text-lg font-semibold mb-4 rounded-[6px] h-[42px] text-display-body text-base flex items-center justify-start gap-2 flex-shrink-0">
            Bank Details
          </div>
          <div className="grid grid-cols-3 gap-4">
            <Form.Item
              name="bankName"
              label="Bank Name"
              rules={[{ required: true }]}
            >
              <Input placeholder="Enter bank name" />
            </Form.Item>

            <Form.Item
              name="accountNumber"
              label="Account Number"
              rules={[{ required: true }]}
            >
              <Input placeholder="12345XXXXXXXX2345" />
            </Form.Item>

            <Form.Item
              name="branchName"
              label="Branch Name"
              rules={[{ required: true }]}
            >
              <Input placeholder="Enter bank branch" />
            </Form.Item>
          </div>
        </div>

        <Space className="flex gap-2 mt-4">
          <Button className="w-[120px]">Cancel</Button>
          <Button type="primary" htmlType="submit" className="w-[120px]">
            Update
          </Button>
        </Space>
      </Form>
    </CustomModal>
  );
}
